import { api } from 'api'
import { CompanyInfo } from 'api/company/companyInfo'
import { DEMO_COMPANY_ID } from '../demoCompany'
import { getDemoData, matchRestRequest } from '../utils'

const DEMO_PERMISSION_ID = 1

export const mockGetWhoami = {
  shouldMock: (request) =>
    matchRestRequest(request, '/company/actor/whoami', 'GET'),
  getResponse: async () => {
    const realCompanyInfo = await fetchRealCompanyInfo()
    const demoData = getDemoData()

    if (!realCompanyInfo) {
      return {
        companies: [],
        permissions: [demoPermissions],
      }
    }

    const takePercentageEstimate =
      demoData.companyOverrides?.takePercentageEstimate ??
      realCompanyInfo.takePercentageEstimate
    const bonusTakePercentageEstimate =
      demoData.companyOverrides?.bonusTakePercentageEstimate ??
      realCompanyInfo.bonusTakePercentageEstimate

    const currentCompanyId = Number(realCompanyInfo.id)
    const groupCompanies = realCompanyInfo.companyGroup?.companies ?? []

    const companiesFromGroup = groupCompanies.map((groupCompany) => {
      const companyId = Number(groupCompany.id)
      const isDefault = companyId === currentCompanyId

      return {
        isDefault,
        companyId,
        companyName: groupCompany.name,
        companyGroup: realCompanyInfo.companyGroup
          ? {
              id: Number(realCompanyInfo.companyGroup.id),
              name: `Group ${realCompanyInfo.companyGroup.id}`,
            }
          : null,
        permissionId: DEMO_PERMISSION_ID,
        isInternalWorkforceEnabled: false,
        logoUrl: isDefault ? realCompanyInfo.logoUrl ?? null : null,
        takePercentageEstimate: isDefault ? takePercentageEstimate : 20,
        bonusTakePercentageEstimate: isDefault
          ? bonusTakePercentageEstimate
          : 20,
        chargeUpfront: isDefault ? realCompanyInfo.chargeUpfront : false,
        w2: isDefault ? realCompanyInfo.w2 : false,
        backfillPolicy: isDefault ? realCompanyInfo.backfillPolicy : false,
        hasVNDLYIntegration: false,
      }
    })

    const companies =
      companiesFromGroup.length > 0
        ? companiesFromGroup
        : [
            {
              isDefault: true,
              companyId: currentCompanyId,
              companyName: realCompanyInfo.name,
              companyGroup: null,
              permissionId: DEMO_PERMISSION_ID,
              isInternalWorkforceEnabled: false,
              logoUrl: realCompanyInfo.logoUrl ?? null,
              takePercentageEstimate,
              bonusTakePercentageEstimate,
              chargeUpfront: realCompanyInfo.chargeUpfront,
              w2: realCompanyInfo.w2,
              backfillPolicy: realCompanyInfo.backfillPolicy,
              hasVNDLYIntegration: false,
            },
          ]

    // Ensure DemoCo is present for switcher demos when the real group omits it
    if (
      !companies.some((company) => company.companyId === DEMO_COMPANY_ID) &&
      currentCompanyId !== DEMO_COMPANY_ID
    ) {
      companies.push({
        isDefault: false,
        companyId: DEMO_COMPANY_ID,
        companyName: 'DemoCo',
        companyGroup: companies[0]?.companyGroup ?? null,
        permissionId: DEMO_PERMISSION_ID,
        isInternalWorkforceEnabled: false,
        logoUrl: null,
        takePercentageEstimate: 20,
        bonusTakePercentageEstimate: 20,
        chargeUpfront: false,
        w2: false,
        backfillPolicy: false,
        hasVNDLYIntegration: false,
      })
    }

    return {
      companies,
      permissions: [demoPermissions],
    }
  },
}

const demoPermissions = {
  id: DEMO_PERMISSION_ID,
  name: 'user',
  description: 'Demo',
  manageBonus: true,
  manageRoles: true,
  manageShift: true,
  manageWorker: true,
  messageWorker: true,
  paymentAccess: true,
  requestSpecificWorker: true,
  workTimeAdjustment: true,
}

async function fetchRealCompanyInfo() {
  const response = await api.post<CompanyInfo>(
    '/company/graphql_dispatch/current_company_7a77e0eb',
    {}
  )
  const company = response.data

  if (!company) {
    return null
  }

  return {
    ...company,
    id: Number(company.id),
    takePercentageEstimate: Number(company.takePercentageEstimate),
    bonusTakePercentageEstimate: Number(company.bonusTakePercentageEstimate),
  }
}
